export default __webpack_public_path__ + "static/media/greenLabelCircle.18eecef3.svg";